import { Button } from "@mui/material";
import { SelectArrowDownIcon } from "../../icons/GenericIcons";

export type DropDownButtsonV2Props = {
  display: React.ReactNode;
  className?: string;
  onClick?: (event: any) => void;
  fullWidth?: boolean;
};

export const DropDownButtonV2 = ({ display, ...others }: DropDownButtsonV2Props) => {
  return (
    <Button
      sx={{
        padding: 0,
        whiteSpace: "nowrap",
        fontSize: "1.0625rem",
        fontWeight: 500,
        "& .MuiSvgIcon-root": {
          marginLeft: "1.4375rem",
        },
        "&:hover": {
          backgroundColor: "transparent",
        },
        "&.MuiButton-contained": {
          padding: "0.75rem 1.25rem",
          borderRadius: "50vh",
        },
        "&.MuiButton-containedPrimary": {
          backgroundColor: "primary.main",
        },
        justifyContent: "space-between",
      }}
      variant={"contained"}
      disableElevation
      disableRipple
      {...others}
    >
      {display} <SelectArrowDownIcon />
    </Button>
  );
};
